import {
  ArrayInput,
  BooleanInput,
  Create,
  FormDataConsumer,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
} from "react-admin";
import { SettingTypes } from "./utils.type";

export function AppSettingsCreate() {
  return (
    <Create>
      <SimpleForm>
        <SelectInput
          source="type"
          choices={Object.values(SettingTypes).map((type) => ({
            id: type,
            name: type,
          }))}
          validate={required()}
        />
        <TextInput source="name" validate={required()} />
        <FormDataConsumer>
          {({ formData }) => {
            if (formData?.type) {
              switch (formData?.type) {
                case SettingTypes.NUMBER: {
                  return <NumberInput source="value" type="number" />;
                }
                case SettingTypes.BOOLEAN: {
                  return <BooleanInput source="value" />;
                }
                case SettingTypes.STRING: {
                  return <TextInput source="value" />;
                }
                case SettingTypes.JSON: {
                  return <JsonInput source="value" label={"Value"} />;
                }

                case SettingTypes.ARRAY: {
                  return (
                    <ArrayInput source="value">
                      <TextInput source="" />
                    </ArrayInput>
                  );
                }

                default: {
                  return <TextInput source="value" />;
                }
              }
            }
          }}
        </FormDataConsumer>
        <BooleanInput
          source="isPublic"
          validate={required()}
          defaultValue={true}
        />
        <TextInput source="description" multiline />
      </SimpleForm>
    </Create>
  );
}

export const JsonInput = ({ source, label }) => {
  //   const { field } = useInput({ source });

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <TextInput
        source={source}
        // {...field}
        label={label}
        multiline
        validate={(value) => validateJson(value)}
      />
    </div>
  );
};

export function validateJson(values) {
  try {
    JSON.parse(values);
    return undefined;
  } catch (e) {
    return "Value must be JSON";
  }
  return undefined;
}
